import { IEditorV3 } from "@azu-business/editor-v3";

export enum eCommentReviewStatus {
  open = "Open",
  resolved = "Resolved",
}

export interface CommentReadDto {
  id: string;
  authorId: number;
  authorDisplayName: string;
  content: IEditorV3;
  commentReviewStatus: eCommentReviewStatus;
  parentId?: string;
  relatedTo?: string;
  createdAt: string;
  updatedAt: string;
  updateCount: number;
  canDelete: boolean;
  entityVersion?: string;
}
